import React from "react";
import "./waitscreen.scss";
import Modal from "react-bootstrap/Modal";
import { confirmationSvg, waitIcon, waitIconDark } from "../../images";
import BlinkingDots from "../../Animations/BlinkingDots/BlinkingDots";
import LightThemeBackground from "../../Animations/LightThemeBackground/LightThemeBackground";
import useTheme from "../../components/useTheme/useTheme";

const WaitScreen = (props) => {
  const {theme} = useTheme()
  return (
    <>
       {theme === "dark" ? <BlinkingDots /> : <LightThemeBackground />}
      <Modal
        {...props}
        animation={false}
        fullscreen={true}
        centered
        className={`waitScreen_popup_modal ${theme === "dark" && "waitScreen_popup_modal--dark-variant-active"}`}
        //   dialogClassName="custom-modal-dialog" // Custom class for backdrop
        backdropClassName="custom-modal-backdrop-wait-screen"
      >
        {/* <Modal.Header closeButton></Modal.Header> */}
        {/* <Modal.Header>
        <button className="custom-cancel-btn" onClick={props.handleClose}>
          <img
            src={modalCloseIcon}
            alt="close-icon"
            className="ctm_img_bussine_edit_about closeIcon_confm_popup"
          />
        </button>
      </Modal.Header> */}
        <Modal.Body className="modal_wrapper_waitscreen">
          <div className="d-flex justify-content-center">
            <img
              src={theme === "dark" ? waitIconDark : waitIcon}
              alt="confirmation"
              className="confrimation_svg"
              height={171}
              width={171}
            />
          </div>
          <div className="waitScreen_popup_modal_heading">Please Wait!</div>
          <div className={`waitScreen_popup_desc ${theme === "dark" && "text-white"}`}>
            "Archinza AI™ is analyzing your business specifics <br /> to find the best
            client matches... <br />This may take a moment."
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default WaitScreen;
